<template>
    <v-container grid-list-md class="fb-post-create-process">
        <v-layout row wrap>
            <v-flex md10>
                <v-form ref="form_fb_post_process">
                    <v-layout align-center row class="pa-0">
                        <v-flex md4>
                            <label class="text-color-vip">Nhập link Instagram cá nhân cần cài VIP:</label>
                        </v-flex>
                        <v-flex md8>
                            <v-text-field
                                    solo
                                    v-model="link"
                                    placeholder="Nhập link Instagram cá nhân"
                                    required
                            ></v-text-field>
                        </v-flex>
                    </v-layout>

                    <!--videoRef-->
                    <v-layout align-center row v-if="videoId">
                        <v-flex offset-md4>
                            <div class="v-sheet theme--light explain">
                                <a href="#videoRef">
                                    <span class="blue_text label-highlight">Video hướng dẫn tạo job</span>
                                </a>
                            </div>
                        </v-flex>
                    </v-layout>

                    <v-layout align-center row>
                        <v-flex md6>
                            <v-flex md12>
                                <label class="text-color-vip">Số lượng comment nhỏ nhất cần tăng mỗi bài viết:</label>
                            </v-flex>
                            <v-flex md12>
                                <v-text-field
                                        solo
                                        v-model="amountMin"
                                        type="number"
                                        :min="minMin"
                                        required
                                ></v-text-field>
                            </v-flex>
                        </v-flex>
                        <v-flex md6>
                            <v-flex md12>
                                <label class="text-color-vip">Số lượng comment lớn nhất cần tăng mỗi bài viết</label>
                            </v-flex>
                            <v-flex md12>
                                <v-text-field
                                        solo
                                        v-model="amountMax"
                                        type="number"
                                        :min="amountMin"
                                        required
                                ></v-text-field>
                            </v-flex>

                        </v-flex>
                    </v-layout>

                    <v-layout align-center row>
                        <v-flex md6>
                            <v-flex md12>
                                <label class="text-color-vip">Số lượng bài viết trong 1 ngày:</label>
                            </v-flex>
                            <v-flex md12>
                                <v-text-field
                                        solo
                                        v-model="noPostDay"
                                        type="number"
                                        required
                                ></v-text-field>
                            </v-flex>
                        </v-flex>
                        <v-flex md6>
                            <v-flex md12>
                                <label class="text-color-vip">Số ngày cần mua Vip:</label>
                            </v-flex>
                            <v-flex md12>
                                <v-text-field
                                        solo
                                        v-model="noDay"
                                        type="number"
                                        required
                                ></v-text-field>
                            </v-flex>
                        </v-flex>
                    </v-layout>

                    <v-layout align-center row class="pa-0">
                        <v-flex md4>
                            <label class="text-color-vip">Bộ lọc từ khóa:</label>
                        </v-flex>
                        <v-flex md8>
                            <v-combobox multiple
                                        v-model="select"
                                        label="Từ khoá"
                                        append-icon
                                        chips
                                        deletable-chips
                                        class="tag-input">
                            </v-combobox>
                        </v-flex>
                    </v-layout>
                    <v-layout align-center row>
                        <v-flex offset-md4>
                            <p style="font-style: italic">Nếu không có từ khóa, hệ thống sẽ Comment tất cả các bài viết
                                Chỉ các bài viết có từ khóa trên đây mới tiến hành bình luận, mỗi từ khóa cách nhau một
                                dấu phẩy</p>
                        </v-flex>
                    </v-layout>
<!--                    <v-layout align-center row>-->
<!--                        <v-flex md4>-->
<!--                            <label class="text-color-vip">Lọc nâng cao:</label>-->
<!--                        </v-flex>-->
<!--                        <v-flex md8 pt-6>-->
<!--                            <v-switch-->
<!--                                    v-model="filter"-->
<!--                                    :label="`ON`"-->
<!--                            ></v-switch>-->
<!--                        </v-flex>-->
<!--                    </v-layout>-->

<!--                    <v-layout align-center row>-->
<!--                        <v-flex v-if="filter" offset-md4>-->
<!--                            <v-row class="ml-1">-->
<!--                                <span> Hệ thống sẽ </span>-->
<!--                                <span class="text-color-vip ml-1">thu phí thêm 40% </span>-->
<!--                                <span class="ml-1"> cho </span>-->
<!--                                <span class="text-color-vip ml-1"> 1 lựa chọn nâng cao</span>-->
<!--                            </v-row>-->
<!--                            <v-row class="ml-1">-->
<!--                                <v-flex md12>-->
<!--                                    <v-card>-->
<!--                                        <v-container>-->
<!--                                            <v-layout align-center>-->
<!--                                                <v-flex md12 row>-->
<!--                                                    <v-flex md3 align-self-center pl-2 class="text-color-vip">-->
<!--                                                        Giới tính:-->
<!--                                                    </v-flex>-->
<!--                                                    <v-flex md9 class="text-color-vip">-->
<!--                                                        <v-radio-group v-model="filterSex" row>-->
<!--                                                            <v-radio label="Tất cả"-->
<!--                                                                     :input-value="filterSex===0"></v-radio>-->
<!--                                                            <v-radio label="Nam" :input-value="filterSex===1"></v-radio>-->
<!--                                                            <v-radio label="Nữ" :input-value="filterSex===2"></v-radio>-->

<!--                                                        </v-radio-group>-->
<!--                                                    </v-flex>-->
<!--                                                </v-flex>-->
<!--                                            </v-layout>-->
<!--                                            <v-layout>-->
<!--                                                <v-flex md12 row class="text-color-vip">-->
<!--                                                    <v-flex md3 align-self-center>-->
<!--                                                        Độ tuổi:-->
<!--                                                    </v-flex>-->
<!--                                                    <v-flex md3>-->
<!--                                                        <v-select-->
<!--                                                                solo-->
<!--                                                                :items="limitAgesFrom"-->
<!--                                                                v-model="limitAgeFrom"-->
<!--                                                                item-text="name"-->
<!--                                                                item-value="value"-->
<!--                                                                class="float-left"-->
<!--                                                        ></v-select>-->
<!--                                                    </v-flex>-->
<!--                                                    <v-flex md3 align-self-center text-center>-->
<!--                                                        Đến-->
<!--                                                    </v-flex>-->
<!--                                                    <v-flex md3>-->
<!--                                                        <v-select-->
<!--                                                                solo-->
<!--                                                                :items="limitAgesTo"-->
<!--                                                                v-model="limitAgeTo"-->
<!--                                                                item-text="name"-->
<!--                                                                item-value="value"-->
<!--                                                                class=""-->
<!--                                                        ></v-select>-->
<!--                                                    </v-flex>-->
<!--                                                </v-flex>-->
<!--                                            </v-layout>-->

<!--                                            <v-layout>-->
<!--                                                <v-flex md12 row class="text-color-vip">-->
<!--                                                    <v-flex md3 align-self-center>-->
<!--                                                        Số bạn bè:-->
<!--                                                    </v-flex>-->
<!--                                                    <v-flex md3>-->
<!--                                                        <v-select-->
<!--                                                                solo-->
<!--                                                                :items="limitFriendsFrom"-->
<!--                                                                v-model="limitFriendFrom"-->
<!--                                                                item-text="name"-->
<!--                                                                item-value="value"-->
<!--                                                                class="float-left"-->
<!--                                                        ></v-select>-->
<!--                                                    </v-flex>-->
<!--                                                    <v-flex md3 align-self-center text-center>-->
<!--                                                        Đến-->
<!--                                                    </v-flex>-->
<!--                                                    <v-flex md3>-->
<!--                                                        <v-select-->
<!--                                                                solo-->
<!--                                                                :items="limitFriendsTo"-->
<!--                                                                v-model="limitFriendTo"-->
<!--                                                                item-text="name"-->
<!--                                                                item-value="value"-->
<!--                                                                class=""-->
<!--                                                        ></v-select>-->
<!--                                                    </v-flex>-->
<!--                                                </v-flex>-->
<!--                                            </v-layout>-->
<!--                                        </v-container>-->
<!--                                    </v-card>-->
<!--                                </v-flex>-->
<!--                            </v-row>-->

<!--                        </v-flex>-->
<!--                    </v-layout>-->

                    <v-layout align-center row>
                        <v-flex md4>
                            <label class="text-color-vip">Nội dung cần comment:</label>
                        </v-flex>
                        <v-flex md8>
                            <v-card class="pa-4">
                                <h5 class="red--text">
                                    {{ noteComment1}}
                                </h5><br>
                                <h5 class="red--text">
                                    {{ noteComment2}}
                                </h5>
                            </v-card>
                        </v-flex>
                    </v-layout>
                    <v-layout align-center row>
                        <v-flex offset-md4>
                            <br>
                            <label>Nhập nội dung bình luận</label>
                            <label class="ml-1"> <strong>(Mỗi dòng tương đương với 1 bình luận)</strong></label><br><br>
                            <div v-for="index in errorArray" :key="index">
                                <v-alert type="error">
                                    Dòng thứ {{ index }} có chứa kí tự đặc biệt
                                </v-alert>
                            </div>
                            <v-btn rounded :color="COLOR.CLICK_MENU_COLOR" dark small>Số lượng: {{ amount}}</v-btn>
                            <v-textarea
                                    solo
                                    v-model="contentComment"
                                    placeholder="Nhập nội dung seeding, mỗi dòng 1 nội dung được tính tiền là 1 bình luận"
                                    height="300px"
                                    class=""
                            ></v-textarea>
                        </v-flex>
                    </v-layout>

                    <v-layout align-center row class="pa-0">
                        <v-flex md12>
                            <v-card dark color="lime lighten-5" class="">
                                <v-card-text class="ml-5 black--text">
                                    <p class="info-account">
                                        Tổng tiền của gói vip sẽ = (Giá tiền order mỗi comment) x (Số lượng comment lớn
                                        nhất mỗi bài) x (Số lượng bài trong ngày) x (Số ngày đăng ký vip)
                                    </p>
                                </v-card-text>
                            </v-card>
                        </v-flex>
                    </v-layout>

                    <v-layout align-center row>
                        <v-flex offset-md4>
                            <v-card class="pa-4">
                                <h5>
                                    {{ noteAmount1}}
                                </h5>
                                <h5 class="red--text">
                                    {{ noteAmount2}}
                                </h5>
                            </v-card>
                        </v-flex>
                    </v-layout>

                    <v-layout align-center row>

                        <v-flex md4>
                            <label class="text-color-vip">Giá tiền mỗi tương tác:</label>
                        </v-flex>
                        <v-flex md8>
                            <v-text-field
                                    solo
                                    v-model="price"
                                    type="number"
                                    :min="priceMin"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>

                    <v-layout align-center row>
                        <v-flex offset-md4>
                            <v-card class="pa-4">
                                <h5 class="red--text">
                                    {{ notePrice}}
                                </h5>
                            </v-card>
                        </v-flex>
                    </v-layout>

                    <v-layout align-center row class="mt-2">
                        <v-flex md4>
                            <label class="text-color-vip">Ghi chú:</label>
                        </v-flex>
                        <v-flex md8>
                            <v-textarea
                                    solo
                                    v-model="notes"
                                    placeholder="Nhập nội dung ghi chú về tiến trình của bạn"
                                    height="70px"
                            ></v-textarea>
                        </v-flex>
                    </v-layout>

                </v-form>

                <v-layout align-center row class="mt-2">
                    <v-flex md12>
                        <v-card :color="COLOR.VIP" height="120px">
                            <v-card-title>
                                <div class="div-total">
                                    <p>
                                        Tổng: <strong>{{totalCoin | currency_init}}</strong> Coin <br>
                                        Bạn sẽ mua vip <strong>{{amountMax}}</strong> Comment / 1 Bài viết trong
                                        <strong>{{ noDay }}</strong> Ngày với giá <strong class="">{{price |
                                        currency_init}}</strong> {{ priceUnit}}
                                    </p>
                                </div>

                            </v-card-title>
                        </v-card>
                    </v-flex>
                </v-layout>

                <v-layout align-center row class="mt-2">
                    <v-flex md12>
                        <v-btn width="100%" height="50px" :color="COLOR.MAIN_COLOR" class="white--text"
                               @click="saveProcess">
                            Tạo tiến trình
                        </v-btn>
                    </v-flex>
                </v-layout>

                <!--video youtube-->
                <v-layout align-center row v-if="videoId" id="videoRef">
                    <v-flex md12>
                        <div class="col-sm-12 mb-n3">
                            <h3 class="text-color">HƯỚNG DẪN SỬ DỤNG</h3>
                        </div>
                        <div class="col-sm-12 mb-n3">
                            <youtube :video-id="videoId" ref="youtube"
                                 @buffering="playing"
                                 @paused="paused"
                                 @ended="paused"
                                 @playing="playing"
                                 width="100%" height="650px">
                            </youtube>
                        </div>
                    </v-flex>
                </v-layout>

            </v-flex>
            <v-flex md2 text_notes>
                <VipCommentMonthAttention/>
            </v-flex>
        </v-layout>
        <v-overlay :value="overlay">
            <v-progress-circular
                    indeterminate
                    color="info"
            ></v-progress-circular>
        </v-overlay>
    </v-container>


</template>

<script>
    import VipCommentMonthAttention from "~/components/vip-comment-month/VipCommentMonthAttention";
    import {COLOR, SEEDING} from "~/config/constant";
    import {checkComment, validURLFb} from "../../common/helper.string";
    import Swal from 'sweetalert2';
    import { VIP_FACE_GET_SEEDING, VIP_COMMENT_MONTH_INSTAGRAM_SAVE_PROCESS, VIP_INSTAGRAM_CALCULATE } from "~/store/actions.type";
    import $ from 'jquery';

    export default {
        name: "FbPostCreateProcess",
        components: {
            VipCommentMonthAttention
        },
        data() {
            return {
                overlay: false,
                // Color chinh
                COLOR: COLOR,
                SEEDING: SEEDING,

                //LINK
                link: "",

                // amount
                amountMin: 50,
                amountMax: 50,
                minMin: 40,

                noPostDay: 2,
                noDay: 7,

                keys: '',
                // bo loc tu khoa
                select: [],
                // items: [],


                // Loc nang cao
                filter: false,
                filterSex: 0,
                limitAgeFrom: '',
                limitAgesFrom: ['NONE'].concat(this.setArray(13, 65, 1)),
                limitAgeTo: '',
                limitAgesTo: [],

                limitFriendFrom: '',
                limitFriendsFrom: ['NONE'].concat(this.setArray(100, 5000, 100)),
                limitFriendTo: '',
                limitFriendsTo: [],

                // Noi dung can comment
                amount: 0,
                noteComment1: "Nghiêm cấm bình luận những nội có cử chỉ, lời nói thô bạo, khiêu khích, trêu ghẹo, xúc phạm nhân phẩm, danh dự của Cá nhân hoặc Tổ chức.",
                noteComment2: "Nếu cố tình buff bạn sẽ bị trừ hết tiền và band khỏi hệ thống vĩnh viễn, và phải chịu hoàn toàn trách nhiệm trước pháp luật.",
                contentComment: '',
                contentCommentArray: [],
                errorArray: [],

                // Gia tien
                price: 2000,
                priceUnit: '  coin/comment',
                priceMin: 200,
                notePrice: "Giá thấp nhất: 200 coin",
                noteAmount1: 'Mẹo nhỏ: Hệ thống ưu tiên chạy các job giá cao trước nên nếu bạn cần gấp bạn có thể set giá job của mình cao hơn 1 vài đồng để chạy nhanh nhất có thể nhé.',
                noteAmount2: 'Lưu ý: Nên buff dư thêm 30 - 50% trên tổng số lượng để tránh tụt.',


                // Ghi chu
                notes: "",

                // Tong so coin
                totalCoin: 140000,
                totalAmount: 50,

                // Rules

                videoId: '',
                videoStatus: true,
            }
        },

        created() {
            this.customDataFromApi();
        },

        watch: {
            noPostDay() {
                this.calculate();
            },
            noDay() {
                this.calculate();
            },
            amountMax() {
                this.calculate();
            },
            filter() {
                this.calculate();
            },
            filterSex() {
                this.calculate();
            },
            limitAgeFrom() {
                this.limitAgesTo = this.setArray(this.limitAgeFrom, 65, 1);
                this.calculate();
            },
            limitAgeTo() {
                this.calculate();
            },
            limitFriendFrom() {
                this.limitFriendsTo = this.setArray(this.limitFriendFrom, 5000, 100);
                this.calculate();
            },
            limitFriendTo() {
                this.calculate();
            },
            contentComment() {
                this.contentCommentArray = this.contentComment.split(/\r\n|\r|\n/);
                let filteredArray = this.contentCommentArray.filter(function (el) {
                    return el.trim() !== "";
                });
                this.contentCommentArray.filter(this.filterByID);
                this.contentCommentArray = filteredArray;
                this.amount = filteredArray.length ? filteredArray.length : 0;
            },
            amount() {
                this.calculate();
            },
            price() {
                this.calculate();
            }
        },
        computed: {},
        mounted() {
            if ($('.menu-instagram-vip-buff').parent().attr('aria-expanded') == "false") {
                $('.menu-instagram-vip-buff').click();
            }
        },
        methods: {
            filterByID(el,index) {
                if (checkComment(el)) {
                    if (!this.errorArray.includes(index + 1))
                    {
                        this.errorArray.push(index + 1);
                    }
                    return true;
                }
                if (this.errorArray.includes(index + 1))
                {
                    let indexArray = this.errorArray.indexOf(index + 1);
                    this.errorArray.splice(indexArray, 1);
                }
                return false;
            },

            async customDataFromApi() {
                let data = await this.$store.dispatch(VIP_FACE_GET_SEEDING, {seeding_type_id: 26});
                if (data) {
                    console.log(data);
                    this.amountMin = parseInt(data.min_like);
                    this.minMin = parseInt(data.min_like);
                    this.amountMax = parseInt(data.max_like);
                    this.price = data.fix_coin;
                    this.priceMin = data.fix_coin
                    this.notePrice = "Giá thấp nhất: " + this.priceMin + " coin";
                    this.calculate();

                    if (data.video) {
                      let videoId = this.youtube_parser(data.video);
                      if (videoId) {
                          this.videoId = videoId;
                      }
                  }
                }
            },

            setArray(min, max, step) {
                let array = [],
                    j = 0;
                for (let i = min; i <= max; i = i + step) {
                    array[j] = i;
                    j++;
                }
                return array;
            },
            validateForm() {
                let valid = true;
                // link or ID
                if (this.link.toString().trim() === '') {
                    return {check: false, message: "Vui lòng nhập link instagram"};
                }
                if (!validURLFb(this.link.toString().trim(), 'instagram')) {
                    return {check: false, message: "Vui lòng nhập đúng link instagram"};
                }
                if (this.amountMin === '') {
                    return {check: false, message: "Chưa Nhập số lượng comment nhỏ nhất"};
                }
                if (this.amountMax === '') {
                    return {check: false, message: "Chưa Nhập số lượng comment lớn nhất"};
                }

                if (parseInt(this.amountMin) > parseInt(this.amountMax)) {
                    return {check: false, message: "Số lượng comment nhỏ nhất và lớn nhất không hợp hệ"};
                }
                if (this.noDay < 1) {
                    return {check: false, message: "Số lượng bài viết cần tăng trong 1 ngày không hợp hệ"};
                }
                if (this.noPostDay < 1) {
                    return {check: false, message: "Số ngày cần mua Vip không hợp hệ"};
                }



                return {check: valid, message: ""};
            },
            async saveProcessBK() {
                Swal.fire('Chức năng này đang bảo trì, nếu bạn muốn tạo job này ngay bây giờ, hãy liên hệ admin qua mục chat facebook');
                return;
            },
            async saveProcess() {
                this.calculate();
                let validateForm = this.validateForm();
                if(this.errorArray.length > 0) {
                    Swal.fire(
                        'Bạn vẫn còn lỗi ở comment',
                        '...',
                        'error'
                    )
                }
                else if (validateForm.check) {
                    try {
                        Swal.fire({
                            title: 'Xác nhận',
                            text: "Bạn có chắc chắn muốn tạo tiến trình ",
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'Đồng ý!',
                            cancelButtonText: 'Không'
                        }).then((result) => {
                            if (result.value) {
                                this.overlay = true;
                                this.saveProcessApi();
                            }
                        })
                    } catch (error) {
                        console.log(error);
                    }
                } else {
                    Swal.fire(
                        validateForm.message,
                        '...',
                        'error'
                    )
                }
            },
            getParams() {
                let params = {
                    link: this.link,
                    min_like: this.amountMin,
                    max_like: this.amountMax,

                    max_post_daily: this.noPostDay,
                    fix_coin_job: this.price,
                    prices: this.totalCoin,
                    note: this.notes,
                    list_comments: this.contentCommentArray,
                    days: this.noDay,
                    key_post_filters: this.select,
                    number_seeding: this.amount
                };
                if (this.filter === true) {
                    if (this.filterSex !== 0) {
                        params.gender = this.filterSex;
                    }
                    if (this.limitAgeFrom !== 'NONE' && this.limitAgeFrom !== '') {
                        params.age_min = this.limitAgeFrom;
                        params.age_max = this.limitAgeTo;
                    }
                    if (this.limitFriendFrom !== 'NONE' && this.limitFriendFrom !== '') {
                        params.friend_min = this.limitFriendFrom;
                        params.friend_max = this.limitFriendTo;
                    }
                }
                return params;
            },
            async saveProcessApi() {
                let check = await this.$store.dispatch(VIP_COMMENT_MONTH_INSTAGRAM_SAVE_PROCESS, this.getParams());
                if (check) {
                    this.overlay = false;
                    this.$router.go();
                } else {
                    this.overlay = false;
                }

            },
            async calculate() {
                let params = {
                    seeding_type: 26,
                    max_like: this.amountMax,
                    days: this.noDay,
                    fix_coin_job: this.price,
                    max_post_daily: this.noPostDay,
                    number_seeding: this.amount

                };
                if (this.filter === true) {
                    if (this.filterSex !== 0) {
                        params.gender = this.filterSex;
                    }
                    if (this.limitAgeFrom !== 'NONE' && this.limitAgeFrom !== '') {
                        params.age_min = this.limitAgeFrom;
                        params.age_max = this.limitAgeTo;
                    }
                    if (this.limitFriendFrom !== 'NONE' && this.limitFriendFrom !== '') {
                        params.friend_min = this.limitFriendFrom;
                        params.friend_max = this.limitFriendTo;
                    }
                }
                let rs = await this.$store.dispatch(VIP_INSTAGRAM_CALCULATE, params);
                if (rs) {
                    this.totalCoin = rs;
                } else {
                    this.totalCoin = 0;
                }

            },

            playing() {
                this.videoStatus = false;
            },
            paused() {
                this.videoStatus = true;
            },
            youtube_parser(url) {
                let regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
                let match = url.match(regExp);
                return (match && match[7].length == 11) ? match[7] : false;
            }
        }
    }
</script>

<style lang="scss">
    @import "../../scss/main";

    .fb-post-create-process {
        background-color: $bgMainColor;
        max-width: 100% !important;

        .v-text-field__details {
            display: none;
        }

        .text-color {
            color: $mainColor;
            font-weight: bold;
        }

        .text-color-vip {
            color: $vip;
            font-weight: bold;
        }

        .div-total {
            width: 100%;
            color: white;
            text-align: center;
        }

        .div-cx {
            height: 60px;

            .cx-img {
                cursor: pointer;

                &hover {
                    opacity: 0.8;
                }
            }

            .cxSelected {
                height: 60px;
                width: 60px;
            }
        }

        .tag-input span.chip {
            background-color: #1976d2;
            color: #fff;
            font-size: 1em;
        }

        .tag-input span.v-chip {
            background-color: #1976d2;
            color: #fff;
            font-size: 1em;
            padding-left: 7px;
        }

        button.v-icon.notranslate.v-chip__close.v-icon--link.v-icon--right.mdi.mdi-close-circle.theme--light {
            color: white;
        }
    }
</style>
